<div class="modal-dialog modal-md  modal-dialog-centered d-block m-0 p-3" #cardListWrapper>
    <div class="modal-header d-flex justify-content-between p-0 border-0">
        <h4 class="fs-18 fw-700 m-0">
            Choose payment method
        </h4>
        <img src="assets/images/icons/cross-icon.svg" alt="" class="hw-24 p-1 cursor rounded-circle border"
            (click)="modalHide()">
    </div>
    <div class="modal-body p-0 mt-4 m-0">
        <ul class="card-list p-0 decoration-none">
            <li class="p-3 mb-3 radius-8 cursor" *ngFor="let card of extra_data.cards_list" (click)="selectCard(card)"
                [ngClass]="{'lightgreen-bg': card === extra_data.selectedCard}">
                <div class="d-flex align-items-center justify-content-between">
                    <span class="d-flex align-items-center">

                        <span class="d-flex align-items-center justify-content-center me-2"
                            style="width: 80px; height:64px ;">
                            <img style="max-width:100%;"
                                [src]="getCardBrandImage(card)"
                                (error)="useFallbackCardImage($event)" />
                        </span>
                        <span>
                            <!-- <h4 class="fs-18 fw-700 m-0 pb-2">{{ getCardHolderName(card) }}</h4> -->
                            <p class="fs-14 fw-500 m-0">**** {{ card.last4 || card.last4 || '----' }}</p>
                        </span>
                    </span>
                    <img src="assets/images/icons/greenTick.svg" alt="" class="hw-32"
                        *ngIf="card === extra_data.selectedCard">
                </div>
            </li>
        </ul>

        <p class="fs-14 fw-500 text-primary mb-4 cursor d-inline-block" (click)="addCardModal()">
            +Add New Card
        </p>
        <div class="d-flex align-items-center p-3 border mb-4 radius-8 bg-lightgrey">
            <img src="assets/images/icons/shield-check.png" alt="" class="me-3">
            <p class="fs-14 fw-600  m-0">
                We adhere entirely to the data security standards of the payment card industry.
            </p>
        </div>
        <button class="btn btn-primary" (click)="changeSelectedCard()">
            Submit
        </button>
    </div>
</div>